// extracted by mini-css-extract-plugin
export default {"headerBlock":"ResetPassword_headerBlock__cGiS4","middleBlock":"ResetPassword_middleBlock__2bcqU"};